<div id="campaign-map">
    <div class="map-headers" *ngIf="mapData.title || mapData.subtitle">
        <finder-component-header
            [data]="mapData.sections"
        ></finder-component-header>
    </div>
    @defer {
        <finder-map
            [defaults]="defaults"
            [markers]="markers"
            [center]="center"
            [paradeRoute]="paradeRoute"
            [maxBounds]="maxBounds"
            [markerOptions]="markerOptions"
        ></finder-map>
    }
    <div class="download-map" *ngIf="mapData.downloadMapUrl">
        <a [href]="mapData.downloadMapUrl"
            target="_blank"
            [attr.aria-label]="mapData.downloadMapAriaLabel"
        ><finder-font-icon name="download" size="s"></finder-font-icon>{{mapData.downloadMapTitle}}</a>
        <a [href]="mapData.downloadViewerUrl"
            target="_blank"
            [attr.aria-label]="mapData.downloadViewer"
            class="sr-only sr-only-focusable"
        >{{mapData.downloadViewer}}</a>
    </div>
</div>
